import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useAuth } from "./context/AuthContext";
import "./Navbar.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

function Navbar() {
  const [click, setClick] = useState(false);
  const [userMenu, setUserMenu] = useState(false);
  //const [infoMenu, setInfoMenu] = useState(false);

  const { user, logout } = useAuth();

  const handleClick = () => {
    //setInfoMenu(false);
    setUserMenu(false);
    setClick(!click);
  };

  const handleNavClose = () => {
    setClick(false);
    //setInfoMenu(false);
    setUserMenu(false);
  };

  // const toggleInfoMenu = () => {
  //   if (window.innerWidth <= 768) {
  //     setInfoMenu(!infoMenu);
  //   }
  // };

  const toggleUserMenu = () => {
    if (window.innerWidth <= 768) {
      setUserMenu(!userMenu);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setClick(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const isElectron = navigator.userAgent.includes("VortexDesktop");

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={handleNavClose}>
          <i className="fa-solid fa-bolt"></i> Vortex Network
        </Link>

        <div className="menu-icon" onClick={handleClick}>
          <i
            className={
              click
                ? "fa-solid fa-xmark"
                : "fa-solid fa-bars"
            }
          ></i>
        </div>

        <ul className={click ? "nav-menu active" : "nav-menu"}>
          <li className="nav-item">
            <Link
              to="/"
              className="nav-links"
              onClick={handleNavClose}
            >
              Home
            </Link>
          </li>

          <li className="nav-item">
            <Link
              to="/forums"
              className="nav-links"
              onClick={handleNavClose}
            >
              Announcements
            </Link>
          </li>

          <li className="nav-item">
            <Link
              to="/faq"
              className="nav-links"
              onClick={handleNavClose}
            >
              <i className="fa-solid fa-gamepad"></i> FAQ
            </Link>
          </li>

          <li className="nav-item">
            <Link
              to="/addons"
              className="nav-links"
              onClick={handleNavClose}
            >
              <i className="fa-solid fa-puzzle-piece"></i> Addons
            </Link>
          </li>

          {/* INFO DROPDOWN */}
          {/* <li
            className="nav-item dropdown"
            onMouseEnter={() =>
              window.innerWidth > 768 && setInfoMenu(true)
            }
            onMouseLeave={() =>
              window.innerWidth > 768 && setInfoMenu(false)
            }
          >
            <span
              className="nav-links"
              onClick={toggleInfoMenu}
            >
              <i className="fa-solid fa-circle-info"></i> Info{" "}
              <i className="fa-solid fa-caret-down"></i>
            </span>

            {infoMenu && (
              <ul className="dropdown-menu">

              </ul>
            )}
          </li> */}

          {/* USER DROPDOWN */}
          {user ? (
            <li
              className="nav-item dropdown"
              onMouseEnter={() =>
                window.innerWidth > 768 &&
                setUserMenu(true)
              }
              onMouseLeave={() =>
                window.innerWidth > 768 &&
                setUserMenu(false)
              }
            >
              <span
                className="nav-links"
                onClick={toggleUserMenu}
              >
                <i className="fa-solid fa-user-circle"></i>{" "}
                {user.username}{" "}
                <i className="fa-solid fa-caret-down"></i>
              </span>

              {userMenu && (
                <ul className="dropdown-menu">
                  <li>
                    <Link
                      to="/profile"
                      onClick={handleNavClose}
                    >
                      <i className="fa-solid fa-id-card"></i>{" "}
                      Profile
                    </Link>
                  </li>
                  
                    {isElectron && (
                      <li>
                        <li className="dropdown-divider"></li>
                        <Link
                          to="/dashboard"
                          onClick={handleNavClose}
                        >
                          <i className=""></i>{" "}
                          Dashboard
                        </Link>
                      </li>
                    )}
                  <li className="dropdown-divider"></li>
                    <li>
                      <Link
                        to="/about"
                        onClick={handleNavClose}
                      >
                        <i className="fa-solid fa-info-circle"></i>{" "}
                        About
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="/contact"
                        onClick={handleNavClose}
                      >
                        <i className="fa-solid fa-envelope"></i>{" "}
                        Contact
                      </Link>
                    </li>                    
                  <li className="dropdown-divider"></li>                    
                  <li>
                    <Link
                      to="/login"
                      onClick={() => {
                        logout();
                        handleNavClose();
                      }}
                    >
                      <i className="fa-solid fa-right-from-bracket"></i>{" "}
                      Logout
                    </Link>
                  </li>
                  
                  
                </ul>
              )}
            </li>
          ) : (
            <li className="nav-item">
              <Link
                to="/login"
                className="nav-links"
                onClick={handleNavClose}
              >
                Login
              </Link>
            </li>
          )}
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;